import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'tutorial-box-dish',
  templateUrl: 'tutorial-box-dish.html',
})
export class TutorialBoxDish {

  //pas de cada tour
  @Input() step: any;
  @Input() href_active: any;
  @Input() href_link: any;

  //total de pasos que te cada tour
  tour_steps_dish = 10;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {
  }

  next() {
    this.globals.tour_step_user++;

    if (this.href_active) {
      /*const link = document.createElement('a');
      link.href = this.href_link;
      link.click();*/

      document.getElementById(this.href_link).scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }

    //open menu sidemenu
    if (this.globals.tour_step_user == 0) {
      //Menu
      const menu = document.getElementsByClassName('menu_tablet');
      for (let i = 0; i < menu.length; i++) {
        const slide = menu[i] as HTMLElement;
        slide.style.width = "";
      }
      //Boto obrir
      const open = document.getElementsByClassName('open_menu_all');
      for (let i = 0; i < open.length; i++) {
        const slide = open[i] as HTMLElement;
        slide.style.display = 'none';
      }
      //Boto tancar
      const close = document.getElementsByClassName('close_menu_all');
      for (let i = 0; i < close.length; i++) {
        const slide = close[i] as HTMLElement;
        slide.style.display = 'block';
      }
      //Textos dels icones
      const text = document.getElementsByClassName('side-menu-text');
      for (let i = 0; i < text.length; i++) {
        const slide = text[i] as HTMLElement;
        slide.style.display = "contents";
      }
    }
  }

  finish() {
    //reset vars
    this.globals.GAtrackView('Tour', 'Tour - Dish - Finish ', this.globals.restaurant.email, 'Finish', 'Tour dish finish', 'Tour', 'Dish');
    this.globals.tour_step_user = -1;
    this.globals.tour = null;
  }

  close() {
    this.globals.GAtrackView('Tour', 'Tour - Dish - Close ', this.globals.restaurant.email, 'Close', 'Tour dish close', 'Tour', 'Dish');

    //close menu sidemenu
    if (this.globals.tour_step_user == 0) {
      //Menu
      const menu = document.getElementsByClassName('menu_tablet');
      for (let i = 0; i < menu.length; i++) {
        const slide = menu[i] as HTMLElement;
        slide.style.width = "50px";
      }
      //Boto obrir
      const open = document.getElementsByClassName('open_menu_all');
      for (let i = 0; i < open.length; i++) {
        const slide = open[i] as HTMLElement;
        slide.style.display = 'block';
      }
      //Boto tancar
      const close = document.getElementsByClassName('close_menu_all');
      for (let i = 0; i < close.length; i++) {
        const slide = close[i] as HTMLElement;
        slide.style.display = 'none';
      }
      //Textos dels icones
      const text = document.getElementsByClassName('side-menu-text');
      for (let i = 0; i < text.length; i++) {
        const slide = text[i] as HTMLElement;
        slide.style.display = "none";
      }
    }
    //reset vars
    this.globals.tour_step_user = -1;
    this.globals.tour = null;
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-box/tutorial-box-dish/tutorial-box-dish.ts